export const getChainExplorer = (chainId: number, walletAddress: string): string => {
  switch (chainId) {
    case 1:
      return `https://etherscan.io/tx/${walletAddress}`;
    case 4:
      return `https://rinkeby.etherscan.io/tx/${walletAddress}`;
    case 137:
      return `https://polygonscan.com/tx/${walletAddress}`;
    case 80001:
      return `https://mumbai.polygonscan.com/tx/${walletAddress}`;
    case 11155111:
      return `https://sepolia.etherscan.io/tx/${walletAddress}`;
    case 5:
      return `https://goerli.etherscan.io/tx/${walletAddress}`;
    default:
      return `https://etherscan.io/tx/${walletAddress}`;
  }
};

export const getEtherScanURL = (chainId: number, hash: string): string => {
  switch (chainId) {
    case 1:
      return `https://etherscan.io/tx/${hash}`;
    case 4:
      return `https://rinkeby.etherscan.io/tx/${hash}`;
    case 137:
      return `https://polygonscan.com/tx/${hash}`;
    case 80001:
      return `https://mumbai.polygonscan.com/tx/${hash}`;
    case 5:
      return `https://goerli.etherscan.io/tx/${hash}`;
    case 11155111:
      return `https://sepolia.etherscan.io/tx/${hash}`;
    case 84532:
      return `https://sepolia.basescan.org/tx/${hash}`;
    case 8453:
      return `https://basescan.org/tx/${hash}`;
    case 900:
      return `https://solscan.io/tx/${hash}`;
    case 901:
      return `https://solscan.io/tx/${hash}?cluster=devnet`;
    case 902:
      return `https://solscan.io/tx/${hash}?cluster=testnet`;
    default:
      return `https://etherscan.io/tx/${hash}`;
  }
};

export const getChainExplorerAddress = (chainId: number, walletAddress: string) => {
  switch (chainId) {
    case 1:
      return `https://etherscan.io/address/${walletAddress}`;
    case 4:
      return `https://rinkeby.etherscan.io/address/${walletAddress}`;
    case 137:
      return `https://polygonscan.com/address/${walletAddress}`;
    case 80001:
      return `https://mumbai.polygonscan.com/address/${walletAddress}`;
    case 5:
      return `https://goerli.etherscan.io/address/${walletAddress}`;
    case 11155111:
      return `https://sepolia.etherscan.io/address/${walletAddress}`;
    default:
      return `https://etherscan.io/address/${walletAddress}`;
  }
};
